import { 
  Zap, 
  Shield, 
  Layers, 
  Users, 
  Cpu, 
  TrendingUp,
  Upload,
  Brain,
  MessageCircle 
} from 'lucide-react';

export const mockData = {
  trustLogos: [
    'HR',
    'Healthcare',
    'Retail & Hospitality',
    'Construction & Engineering', 
    'Education',
    'Public Sector'
  ],
  
  features: [
    {
      icon: Zap,
      title: 'Instant Answers',
      description: 'No more digging through folders or waiting for responses. Ask and receive accurate answers from your knowledge base in seconds, not hours.'
    },
    {
      icon: Shield,
      title: 'HR-Ready AI',
      description: 'Built with enterprise security and compliance in mind. Your sensitive documents stay protected while remaining easily accessible to authorized teams.'
    },
    {
      icon: Layers,
      title: 'Easy Integration',
      description: 'Connect your existing documents, systems, and workflows without disruption. VioQbase adapts to your processes, not the other way around.'
    }
  ],

  useCases: [
    {
      icon: Users,
      title: 'For HR Teams',
      description: 'Empower your HR team to provide instant, accurate answers about policies, benefits, and procedures without endless email chains or manual searches.',
      benefits: [
        'Instant policy clarifications',
        'Reduced repetitive inquiries',
        'Consistent information delivery',
        'Better employee satisfaction'
      ]
    },
    {
      icon: Cpu,
      title: 'For IT & Ops',
      description: 'Give your technical teams immediate access to procedures, troubleshooting guides, and system documentation to resolve issues faster.',
      benefits: [
        'Faster incident resolution',
        'Self-service documentation',
        'Reduced support tickets',
        'Improved system uptime'
      ]
    },
    {
      icon: TrendingUp,
      title: 'For Executive Leaders',
      description: 'Enable data-driven decisions with instant access to reports, metrics, and strategic documents across all departments.',
      benefits: [
        'Quick access to KPIs',
        'Informed decision making',
        'Strategic document retrieval',
        'Cross-department visibility'
      ]
    }
  ],

  howItWorks: [
    {
      icon: Upload,
      title: 'Connect Your Documents',
      description: 'Provide your existing documents, policies, and knowledge base. VioQbase securely processes and organizes everything for instant access.'
    },
    {
      icon: Brain,
      title: 'Train the AI',
      description: 'Our intelligent system learns your content and context, understanding relationships between documents and creating comprehensive knowledge maps.'
    },
    {
      icon: MessageCircle,
      title: 'Ask & Receive',
      description: 'Your team can now ask questions naturally and receive accurate, contextual answers instantly via voice or text interface.'
    }
  ],

  footerLinks: [
    {
      title: 'Product',
      links: [
        { name: 'Features', href: '/features' },
        { name: 'Use Cases', href: '/use-cases' },
        { name: 'Book Demo', href: '#', action: 'demo' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About', href: '/about' },
        { name: 'Contact', href: '/contact' }
      ]
    },
    {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', href: '/privacy' },
        { name: 'Cookie Policy', href: '/cookies' }
      ]
    }
  ]
};